import api from './api';

export const customerContactService = {
  /**
   * Create a customer contact log entry.
   */
  createCustomerContact: async (fundType, type, date) => {
    const response = await api.post('/customer-contact/create', {
      fundType,
      type,
      date,
    });
    return response.data;
  },
};